import * as React from 'react';

import { cn } from '../../lib/utils';

export interface EyebrowProps extends React.ComponentProps<'div'> {
  rule?: boolean;
}

export function Eyebrow({
  className,
  children,
  rule = true,
  ...props
}: EyebrowProps) {
  return (
    <div className={cn('flex flex-col', className)} {...props}>
      <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-brand-red">
        {children}
      </span>
      {rule && (
        <span
          aria-hidden
          className="mt-2 h-[1.5px] w-8 bg-brand-red"
        />
      )}
    </div>
  );
}
